import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './administratorAddContainerActions'

const initialState = {
  submitAdministrator: false,
  submittingAdministrator: false,
  submittedAdministrator: false,
  resetPasswordSent: false,
  administrator: {
    firstName: null,
    lastName: null,
    emailAddress: null
  },
  isInvalid: {
    formIsValid: false,
    firstName: {
      message: null,
      isInvalid: false
    },
    lastName: {
      message: null,
      isInvalid: false
    },
    emailAddress: {
      message: null,
      isInvalid: false
    }
  }
}

export default (state = initialState, action) => {
  const newState = copyAdministratorAddState(state)
  const { setting, submit, submitting, submitted, resetPassword } = events

  switch (action.type) {
    case setting.firstName:
      newState.administrator.firstName = cloneDeep(action.firstName)
      newState.isInvalid.firstName = cloneDeep(action.validationResult)
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case setting.lastName:
      newState.administrator.lastName = cloneDeep(action.lastName)
      newState.isInvalid.lastName = cloneDeep(action.validationResult)
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case setting.emailAddress:
      newState.administrator.emailAddress = cloneDeep(action.emailAddress)
      newState.isInvalid.emailAddress = cloneDeep(action.validationResult)
      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case submit.administrator:
      newState.resetPassword = false
      newState.submitAdministrator = true
      return newState
    case submitting.administrator:
      newState.submitAdministrator = false
      newState.submittingAdministrator = true
      return newState
    case submitted.administrator:
      newState.submittedAdministrator = true
      newState.administrator = cloneDeep(initialState.administrator)
      newState.isInvalid = cloneDeep(initialState.isInvalid)
      return newState
    case resetPassword.administrator:
      newState.submittingAdministrator = false
      newState.resetPasswordSent = true
      return newState
    default:
      return newState
  }
}

const isFormValid = (state) => {
  const isInvalid = state.isInvalid
  // Coerce to a boolean: fields that have not been touched yet carry no `valid` flag, which
  // otherwise leaves formIsValid as undefined rather than false.
  return Boolean(isInvalid.firstName.valid &&
    isInvalid.lastName.valid &&
    isInvalid.emailAddress.valid)
}

const copyAdministratorAddState = (state) => {
  const newState = cloneDeep(state)
  return newState
}
